import CtflAsset from './ctfl-asset'

export default CtflAsset
